import { z } from "zod";

export const discoverEventsSchema = z.object({
  start: z.string().min(1, "start is required (YYYY-MM-DD)"),
  end: z.string().min(1, "end is required (YYYY-MM-DD)"),
  sport: z.string().optional(),
  school: z.string().optional(),
  type: z.string().optional(),
  search: z.string().optional(),
  province: z.string().optional(),
  page: z.coerce.number().int().min(1).default(1),
  per_page: z.coerce.number().int().min(1).max(100).default(20),
});

export type DiscoverEventsInput = z.infer<typeof discoverEventsSchema>;
